import { S } from "../theme";

const INJECTION_SITES = [
  { id: "L delt", label: "Left Delt", view: "front", cx: 30, cy: 24 },
  { id: "R delt", label: "Right Delt", view: "front", cx: 70, cy: 24 },
  { id: "L abdomen", label: "Left Abdomen", view: "front", cx: 40, cy: 46 },
  { id: "R abdomen", label: "Right Abdomen", view: "front", cx: 60, cy: 46 },
  { id: "L love handle", label: "Left Flank", view: "front", cx: 28, cy: 50 },
  { id: "R love handle", label: "Right Flank", view: "front", cx: 72, cy: 50 },
  { id: "L quad", label: "Left Quad", view: "front", cx: 40, cy: 70 },
  { id: "R quad", label: "Right Quad", view: "front", cx: 60, cy: 70 },
  { id: "L glute", label: "Left Glute", view: "back", cx: 40, cy: 52 },
  { id: "R glute", label: "Right Glute", view: "back", cx: 60, cy: 52 },
  { id: "L dorsglute", label: "Left Upper Glute", view: "back", cx: 38, cy: 46 },
  { id: "R dorsglute", label: "Right Upper Glute", view: "back", cx: 62, cy: 46 },
];

function siteLabel(siteId) {
  return INJECTION_SITES.find(s => s.id === siteId)?.label || siteId;
}

// A peptide needs a site only when it's actually injected. Routes read like
// "SubQ", "SubQ or IM", "IV or IM", "Intranasal", "Oral or Topical".
function isInjectableRoute(route) {
  return /\b(subq|sub-q|im|iv|subcutaneous|intramuscular)\b/i.test(route || "");
}

// `logs` is assumed newest-first (created_at desc).
function recentAtSite(logs, siteId, n = 5) {
  return logs.filter(l => l.site === siteId).slice(0, n);
}

function daysSinceSite(logs, siteId) {
  const last = logs.find(l => l.site === siteId);
  if (!last) return null;
  return Math.floor((Date.now() - new Date(last.created_at).getTime()) / 86400000);
}

function siteColorFor(logs, siteId) {
  const d = daysSinceSite(logs, siteId);
  if (d === null) return S.surface2;   // never used — available
  if (d <= 2) return S.accent2;        // recent — avoid (orange)
  if (d <= 6) return "#c9a227";        // getting there (amber)
  return S.accent;                     // rested — good to use (green)
}

// Reusable body silhouette. Pass onSelectSite to make zones clickable and
// onHoverSite to surface a site's recent history on hover.

export { INJECTION_SITES, siteLabel, isInjectableRoute, recentAtSite, daysSinceSite, siteColorFor };
